import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw, Send } from 'lucide-react';
import InvoiceStatusBadge from './InvoiceStatusBadge';

const NOTIF = { RC: 'Ricevuta di consegna', NS: 'Notifica di scarto', MC: 'Mancata consegna', AT: 'Attestazione di trasmissione', DT: 'Decorrenza termini', NE: 'Esito committente' };

export const InvoiceSdiPanel = ({ invoice, errors, busy, onRefresh }) => {
  const sdi = invoice?.sdi || {};
  return (
    <Card data-testid="invoice-sdi-panel" className="card-swiss">
      <CardHeader className="py-3">
        <CardTitle className="text-sm font-semibold font-['Manrope'] flex items-center gap-2">
          <Send className="w-4 h-4" /> Stato SDI <InvoiceStatusBadge status={invoice.status} testId="invoice-status-badge" />
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 space-y-3 text-sm">
        {invoice.status !== 'draft' && <p data-testid="invoice-status-label" className="text-muted-foreground">{invoice.status_label}</p>}
        {invoice.error && (
          <div data-testid="invoice-error" className="flex gap-2 p-3 rounded-md bg-red-50 text-red-800 border border-red-200">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /><span>{invoice.error}</span>
          </div>
        )}
        {errors?.length > 0 && (
          <div data-testid="invoice-check-errors" className="p-3 rounded-md bg-amber-50 text-amber-900 border border-amber-200">
            <p className="font-semibold mb-1">Da correggere prima dell'invio:</p>
            <ul className="list-disc pl-5 space-y-0.5">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
        )}
        {sdi.upload_filename && (
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div><span className="text-muted-foreground">File:</span> <span className="font-['JetBrains_Mono']">{sdi.upload_filename}</span></div>
            <div><span className="text-muted-foreground">ID SDI:</span> <span data-testid="invoice-id-sdi" className="font-['JetBrains_Mono']">{sdi.id_sdi || '—'}</span></div>
            <div><span className="text-muted-foreground">Inviata il:</span> {new Date(sdi.sent_at).toLocaleString('it-IT')}</div>
            <div><span className="text-muted-foreground">Ambiente:</span> {sdi.environment === 'production' ? 'Reale' : 'Prova (demo)'}</div>
          </div>
        )}
        {(sdi.notifications || []).length > 0 && (
          <ul className="text-xs space-y-1 border-t pt-2">
            {sdi.notifications.map((n, i) => (
              <li key={i}><b>{NOTIF[n.type] || n.type}</b> · {n.date ? new Date(n.date).toLocaleString('it-IT') : ''} {n.result ? `· ${n.result}` : ''}</li>
            ))}
          </ul>
        )}
        {sdi.upload_filename && (
          <Button data-testid="refresh-invoice-status-btn" type="button" variant="outline" size="sm" onClick={onRefresh} disabled={busy}>
            <RefreshCw className="w-3.5 h-3.5 mr-2" /> Aggiorna stato
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default InvoiceSdiPanel;
